export default "__VITE_ASSET__AbOmUnNK__"